import React, { ReactNode, useEffect, useRef, useState } from 'react';

import { TooltipContent, TooltipWrapperContainer } from './TooltipWrapper.elements';
import { TooltipWrapperProps } from './';

interface Props extends TooltipWrapperProps {
  children: ReactNode | ReactNode[];
}

// TODO: Add collision detection for automatic positioning
export const TooltipWrapper = ({
  children,
  Tooltip,
  className,
  gridArea,
  top,
  bottom,
  left,
  right,
  isOpen,
  width,
  position,
  ...rest
}: Props): JSX.Element => {
  const parentRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const wrapperClassName = className ? `tooltip-wrapper ${className}` : `tooltip-wrapper`;
  const tooltipClassName = `tooltip tooltip--${bottom ? `bottom` : left ? `left` : `top`}`;
  const settings = {
    gridArea,
    top,
    bottom,
    left,
    right,
    isOpen,
    width
  };

  const [tooltipPosition, setTooltipPosition] = useState({ bottom: '50%', left: '50%' });

  const handleTooltipPosition = () => {
    if (parentRef.current) {
      const position = parentRef.current?.getBoundingClientRect();
      if (position) {
        setTooltipPosition({
          bottom: window.innerHeight - position.top + 'px',
          left: position.left + position.width / 2 + 'px'
        });
      }
    }
  };

  useEffect(() => {
    handleTooltipPosition();
  }, [parentRef]);

  useEffect(() => {
    if (!position) return;
    window.addEventListener('scrollend', handleTooltipPosition);
    return () => window.removeEventListener('scrollend', handleTooltipPosition);
  }, []);

  return (
    <TooltipWrapperContainer className={wrapperClassName} {...settings} ref={parentRef}>
      {children}
      <TooltipContent
        ref={tooltipRef}
        className={`${tooltipClassName} ${position}`}
        fixedBottom={tooltipPosition.bottom}
        fixedLeft={tooltipPosition.left}
        {...rest}
        rightShift={rest.rightShift}
      >
        {Tooltip}
      </TooltipContent>
    </TooltipWrapperContainer>
  );
};
